<template>
  <div v-if="show" :class="[floor.$row, floor.$style]" :style="styleVars">
    <div class="goods-column" v-for="(column, index) of columns" :key="index">
      <div class="top-image-box" v-if="show.topImage">
        <img
          class="top-image"
          :src="column.style.topImageUrl"
          @click="onTopImageClick(column.style)"
        />
        <div
          v-if="show.rankingExplain"
          class="explain"
          @click.stop="onJumpToExplain(column)"
        >
          榜单说明
        </div>
      </div>
  
      <div
        :class="['goods-box', ranks[column.style.rankStyle]]"
        v-if="column.goods.length"
      >
        <div
          :class="['goods', item.$class]"
          v-for="(item, idx) of column.goods"
          :key="item.id"
          @click="onJumpTo(item, index)"
        >
          <div class="item">
            <div class="left">
              <div class="num" v-if="item.$num">{{ item.$num }}</div>
              <c-image
                class="goods-image"
                :src="item.$coverUrl + suffix"
                fit="cover"
                lazy-load
              />
            </div>
            <div class="middle">
              <div class="name">{{ item.$name }}</div>
              <div
                class="sub-title"
                v-if="show.middle.subTitle && item.itemSubtitle"
              >
                {{ item.itemSubtitle }}
              </div>
              <!-- v-if="item.$showView1" -->
              <div class="view1" v-if="item.$showView1">
                <div class="label-box" v-if="show.middle.label">
                  <div class="label" v-if="item.marketTag1">
                    {{ item.marketTag1 }}
                  </div>
                  <div class="label" v-if="item.marketTag2">
                    {{ item.marketTag2 }}
                  </div>
                </div>
                <div
                  class="sales"
                  v-if="show.middle.monthSales && item.thirtySaleCount"
                >
                  月销{{ item.thirtySaleCount }}件
                </div>
              </div>
              <div class="tag" v-if="show.middle.tag && item.$tag">
                <div class="value">{{ item.$tag }}</div>
              </div>
              <div class="view2">
                <div class="price" v-if="show.middle.price">
                  ¥{{ item.$price }}
                </div>
                <div
                  class="marking-price"
                  v-if="show.middle.markingPrice && item.$discount"
                >
                  <div class="value">¥{{ item.markingPrice }}</div>
                  <div class="discount">{{ item.$discount }}</div>
                </div>
                <div class="btn" v-if="show.middle.btn">去抢购</div>
              </div>
            </div>
            <div class="right" v-if="show.right">
              <div class="price">¥{{ item.$price }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utils from '@/utils/common';
import { navigateTo, chunkArray } from '@/views/activities/utils';
import CImage from '@/views/activities/components/c-image';
export default {
  components: { CImage },
  props: {
    home: Object,
    floor: Object
  },
  data() {
    return {
      show: undefined,
      columns: [],
      ranks: {
        1: 'ranking-style-one',
        2: 'ranking-style-two',
        3: 'ranking-style-three',
        4: 'ranking-style-four'
      },
      suffix: '?x-oss-process=style/style_shareatlas_img'
    };
  },
  computed: {
    styleVars() {
      const { floor } = this;
      return {
        '--floor-padding-left': `-${utils.rem2px(floor.paddingLeft)}`,
        '--floor-padding-right': `-${utils.rem2px(floor.paddingRight)}`
      };
    },
    isGoods() {
      return this.floor.goodsType === 1;
    },
    isDataSource() {
      return this.floor.goodsType === 2;
    },
    isRankingList() {
      return this.floor.goodsType === 3;
    }
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      if (this.unwatch) this.unwatch();
      if (!this.home.$isCache || this.isGoods) {
        this.normalizeFloor();
      }
      this.unwatch = this.$watch('floor', this.init);
    },
    normalizeFloor() {
      const { floor, columns } = this;
      const [column1, column2] = columns;
      const style1 = floor.rankStyleVO;
      const style2 = floor.rankStyleVO2;
      const source1 = floor.rankDatasourceVO;
      const source2 = floor.rankDatasourceVO2;
      this.columns = [];
      this.show = this.normalizeShow();
      if (this.isGoods) {
        if (floor.items) {
          this.columns.push({
            style: style1,
            goods: this.normalizeGoods(floor.items, style1)
          });
        }
        if (floor.items2 && floor.items2.length) {
          this.columns.push({
            style: style2,
            goods: this.normalizeGoods(floor.items2, style2)
          });
        }
      } else if (this.isDataSource) {
        if (source1) {
          this.columns.push({
            style: style1,
            source: source1,
            goods: column1 ? column1.goods : []
          });
          this.getDataSourceGoods(0);
        }
        if (source2) {
          this.columns.push({
            style: style1,
            source: source2,
            goods: column2 ? column2.goods : []
          });
          this.getDataSourceGoods(1);
        }
      } else if (this.isRankingList) {
        if (source1) {
          this.columns.push({
            style: style1,
            source: source1,
            goods: column1 ? column1.goods : []
          });
          this.getRankingGoods(0);
        }
        if (source2) {
          this.columns.push({
            style: style1,
            source: source2,
            goods: column2 ? column2.goods : []
          });
          this.getRankingGoods(1);
        }
      }
    },
    normalizeShow() {
      const { floor } = this;
      const row = floor.$row.split('-')[1];
      const style = floor.$style.split('-')[1];
      const display = floor.$display;
      const show = {
        rankingExplain: display.rankingExplain,
        middle: {
          name: true,
          subTitle: display.goodsSubTitle,
          label: display.marketLabel,
          monthSales: false,
          markingPrice: display.markingPrice
        },
        right: false
      };
      switch (row) {
        case 'one':
          switch (style) {
            case 'one':
              show.topImage = true;
              show.right = true;
            case 'two':
              show.right = true;
              break;
            case 'three':
              show.middle.tag = true;
              show.middle.price = true;
              show.middle.btn = true;
              show.middle.monthSales = display.monthSales;
              break;
            case 'four':
              show.topImage = true;
              show.middle.tag = display.goodsDiscount;
              show.middle.price = true;
              show.middle.monthSales = display.monthSales;
              break;
          }
          break;
        case 'two':
          switch (style) {
            case 'one':
              show.topImage = true;
              show.middle.subTitle = false;
              show.middle.tag = false;
              show.middle.label = false;
              show.middle.price = true;
              break;
          }
          break;
      }
      return show;
    },
    normalizeGoods(goods, style, step) {
      const addZero = (v) => (v < 10 ? `0${v}` : `${v}`);
      const isStyle1 = style.rankStyle === 1;
      step = step || 0;
      goods.forEach((item, index) => {
        const num = step + index + 1;
        const showView1 =
          item.marketTag1 || item.marketTag2 || item.thirtySaleCount;
        const discountTag =
          item.discountTag ||
          item.discountStairDesc ||
          item.discountCouponStr ||
          item.couponAmountTag;
        let tag;
        if (item.indexImage) {
          this.$set(item, '$coverUrl', item.indexImage.imageUrl);
        }
        if (num > 3 && num <= 100) {
          this.$set(item, '$num', isStyle1 ? addZero(num) : num);
        }
        if (item.canReceiveCoupon) {
          tag = item.canReceiveCoupon.couponTag;
        }
        if (discountTag) {
          tag = discountTag;
        }
        const klass = num <= 3 ? `goods${num}` : num > 100 ? 'goods-max' : '';
        this.$set(item, '$class', klass);
        this.$set(item, '$tag', tag);
        this.$set(item, '$discount', utils.useDiscount(item));
        this.$set(item, '$goodsId', item.goodId || item.refId);
        this.$set(item, '$branchId', item.branchId || item.branchNo);
        this.$set(item, '$logoId', item.logoId || item.branchLogoId);
        this.$set(item, '$price', item.goodsPrice || item.price);
        this.$set(item, '$name', item.goodsName || item.itemName);
        this.$set(item, '$showView1', Boolean(showView1));
      });
      return goods;
    },
    getDataSourceGoods(index) {
      const parse = (v) => {
        try {
          v = JSON.parse(v);
        } catch (e) {
          v = [];
        }
        return v;
      };
      const types = {
        1: 'y',
        2: 'n'
      };
      const column = this.columns[index];
      const { source } = column;
      const { shopId } = this.$route.query;
      const params = {
        type: 'PRODUCT',
        isScreen: 'y',
        pageIndex: 1,
        pageSize: source.limit,
        categoryLevelId4s: parse(source.categoryFilter),
        branchIds: parse(source.branchIds),
        stock: source.stock,
        priceRanges: source.priceRangeList,
        discount: source.discount,
        orderRule: source.orderRule,
        isVirtual: types[source.goodType],
        goodsNameList: source.goodsNameList || [],
        shopRatioList: source.shopRatioList || [],
        shopFrontCount: source.shopFrontCount || '',
        conditionFilterParam: {
          categoryFilter: source.categoryFilter,
          pointBranchIds: source.pointBranchIds,
          itemName: source.itemName,
          itemNameNot: source.itemNameNot,
          createTimeType: source.createTimeType,
          createTimeInterval: source.createTimeInterval,
          goodsIdNotIn: source.goodsIdNotIn
        }
      };
      if (shopId) {
        params.shopId = shopId;
      }
      if (source.mixTopList) {
        params.topDatas = source.mixTopList.map((item) => ({
          extraScore: item.sort,
          id: item.idValue,
          type: 'PRODUCT'
        }));
      }
      this.http({
        url: '/search/es/mixed/datasource',
        method: 'POST',
        parmes: params
      }).then((data) => {
        if (column !== this.columns[index]) return;
        if ((data.code = 200 && (data = data.data))) {
          const product = data.productAndDiscovers;
          const goods = (product && product.data) || [];
          column.goods = this.normalizeGoods(goods, column.style);
        }
      });
    },
    getRankingGoods(index) {
      const column = this.columns[index];
      const { id, limit } = column.source;
      this.http({
        url: `/dpc/rank/config/queryGoodsIdListByRankId/${id}`,
        method: 'GET'
      }).then((data) => {
        if (data.code === 200) {
          let ids = (data.data || []).slice(0, limit);
          if (!ids.length) {
            column.goods = [];
            return;
          }
          const len = ids.length;
          const size = len <= 20 ? len : 10;
          const ids1 = ids.slice(0, size);
          const ids2 = ids.slice(size, len);
          let loading = false;
          let otherGoods;

          const success = (goods) => {
            if (!loading) {
              // 第二页数据回来，第一页数据还没回来时
              // 先将goods存储起来，等第一页数据回来了
              // 再将它拼接
              otherGoods = goods;
              return;
            }
            column.goods = column.goods.concat(goods);
            if (otherGoods) {
              column.goods = column.goods.concat(otherGoods);
              otherGoods = null;
            }
          };

          // 第一页
          this.doGetRankingGoods(ids1, column, 0).then((data) => {
            loading = true;
            column.goods = [];
            success(data);
          });

          // 第二页
          if (ids2.length) {
            this.doGetRankingGoods(ids2, column, size).then(success);
          }
        }
      });
    },
    doGetRankingGoods(idIn, column, step) {
      return new Promise((resolve) => {
        const success = (data) => {
          if (data.code === 200 && (data = data.data)) {
            const product = data.productAndDiscovers;
            const goods = (product && product.data) || [];
            data = this.normalizeGoods(goods, column.style, step);
            resolve(data);
          }
        };
        const fail = () => {
          resolve([]);
        };
        const parmes = {
          idIn,
          pageIndex: 1,
          pageSize: idIn.length
        };
        this.http({
          url: '/search/es/mixed/datasource',
          method: 'POST',
          parmes
        })
          .then(success)
          .finally(fail);
      });
    },
    onTopImageClick(style) {
      if (style.linkId) {
        navigateTo(this, {
          pageLinkType: 11, // 二级页面
          pageLinkValue: style.linkId
        });
      }
    },
    onJumpTo(item, index) {
      const { floor } = this;
      let type = item.goodsLinkType || floor.goodsLinkType;
      let value = item.goodsLinkValue || floor.goodsLinkValue;
      switch (type) {
        case 1: // 商品详情页
          type = 3;
          value = item.$goodsId;
          break;
        case 2: // 二级页面
          type = 11;
          break;
        case 3: // 店铺主页
          type = 4;
          value = item.$branchId;
          break;
        case 4: // 品牌首页
          type = 10;
          value = item.$logoId;
          break;
        case 5: // 商品详情落地页
          type = 53;
          value = item.$goodsId;
          break;
        case 6: // 店铺主页落地页
          type = 54;
          value = item.$branchId;
          break;
      }
      this.uploadClickGio(item, value, index);
      navigateTo(this, {
        pageLinkType: type,
        pageLinkValue: value,
        goodsId: item.$goodId
      });
    },
    onJumpToExplain(column) {
      this.$router.push({
        name: 'rankingExplain',
        query: {
          id: column.source.id
        }
      });
    },
    uploadClickGio(item, value, index) {
      const { home, floor } = this;
      const shared = {
        pageType_var: home.$pageName,
        dataSourceType_var: item.goodsLinkType,
        dataSourcePageID_var: value
      };
      switch (home.$from) {
        case 'home':
          gio('track', 'flowLocationClick', {
            indexId_var: home.contentPageId,
            entryType_vara: floor.modelTitle,
            entryType_floor_var: floor.$index,
            position_var: index,
            sort_var: '',
            ...shared
          });
          break;
        case 'activity':
          gio('track', 'activityFlowLocationClick_var', {
            secondPageID_var: `${home.contentPageId}`,
            entryType_vara: '商品排行榜',
            entryType_floor_var: floor.$index,
            position_var: String(index),
            sort_var: '',
            positonName_var: item.goodsName,
            shopID_var: 'n', //切换商场ID  ver607 二级页面流量位点击
            belongShop_var: 'n', //归属商场ID
            // belongShop_var:(item&&item.shopId)||"n",  //归属商场ID
            ...shared
          });
          break;
      }
    }
  }
};
</script>

<style lang="less" scoped>
@import url('./css/base.less');
@import url('./css/row-one.less');
@import url('./css/row-two.less');
</style>
